import React, { useState } from 'react';
import Moment from 'react-moment';
import EventModal from '../pages/messages/event_modal';
import {Card, Toolbar, Divider, Dialog, IconButton, Tooltip } from '@mui/material';
import DocType from './document_type';
import { Redirect } from 'react-router-dom';
import { TestCase } from '../pages/testing/cases';
import CloseIcon from '@mui/icons-material/Close';

interface DocumentToolbarProps {
    metadata: any;
    children?: React.ReactNode;
    mostRecentEvent?: any;
    title?: React.ReactNode;
    testCaseSummary?: any;
    mostRecentPost?: any;
    [key: string]: any;
}

const DocumentToolbar = (props: DocumentToolbarProps) => {
    const [showTestCase, setShowTestCase] = useState<boolean>(false);
    const [redirect, setRedirect] = useState<string | undefined>(undefined);
    const [eventId, setEventId] = useState<any>(undefined);
    const [eventViewed] = useState<any>(undefined);

    const stripHtml = (html?: string) => {
        if(!html){
            return html;
        }
        let temporalDivElement = document.createElement("div");
        temporalDivElement.innerHTML = html;
        return temporalDivElement.textContent || temporalDivElement.innerText || "";
    };

    const clickPosts = () => {
        let postPanel = document.getElementById("postPanel")!;
        if(postPanel.className.indexOf("Mui-expanded") < 0){
            postPanel.click();
        }
        postPanel.scrollIntoView(true);
    };

    let {metadata, children, mostRecentEvent, title, testCaseSummary, mostRecentPost, ...rest} = props;
    if(redirect){
        return <Redirect to={redirect}/>;
    }
    return (
        <Card {...rest}>
              <Toolbar className='lbdocbar' style={{display: 'flex'}}>
                  <Tooltip title={title} enterDelay={300} disableInteractive>
                      <div style={{flex: 1, textAlign: 'left', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{title}</div>
                  </Tooltip>
                  <div className='noPrint' style={{display: 'flex', flexShrink: 0, marginLeft: '8px'}}>
                      {children}
                  </div>
              </Toolbar>
              <Toolbar className='lbstatusbar statusColor' {...({statuscode: metadata.Status} as any)}><DocType docType={metadata.DocumentType}/> Status: {metadata.StatusDescription || metadata.Status}<span style={{right: '24px', position: 'absolute'}}>Received: <Moment format='MM/DD/YYYY h:mm A'>{metadata.Date}</Moment> </span></Toolbar>
              {testCaseSummary ? <Toolbar style={{fontWeight: 'bold', minHeight: '50px', lineHeight: '50px'}}>Instructions for test case: <span style={{cursor: 'pointer', marginLeft: '0.3rem', color: '#4b9ec9'}}  onClick={() => setShowTestCase(true)}>{testCaseSummary.TestName}</span></Toolbar> : ''}
              {testCaseSummary && mostRecentEvent ? <Divider/> : ''}
              {mostRecentEvent ? <Toolbar style={{fontWeight: 'bold', minHeight: '50px', lineHeight: '50px'}}>Most recent event: <span style={{cursor: 'pointer', marginLeft: '0.3rem', color: '#4b9ec9'}} onClick={async () => {await setEventId(null); setEventId(mostRecentEvent.Id)}}>{mostRecentEvent.Summary}</span></Toolbar> : ''}
              {(testCaseSummary || mostRecentEvent) && mostRecentPost ? <Divider/> : ''}
              {mostRecentPost ? <Toolbar className='postToolbar' style={{fontWeight: 'bold', minHeight: '50px', lineHeight: '50px'}}>
                <span style={{minWidth: 'fit-content'}}>Most recent message from {mostRecentPost.SenderName}:</span>
                <span onClick={clickPosts} style={{textAlign: 'left', color: '#4b9ec9', marginLeft: '0.3rem', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxHeight: '50px', cursor: 'pointer', overflow: 'hidden'}}>{stripHtml(mostRecentPost.Body)}</span>
                </Toolbar> : ''}
              <EventModal eventId={eventId} viewed={eventViewed}/>
              {testCaseSummary && <Dialog open={showTestCase} maxWidth="lg" fullWidth onClose={() => setShowTestCase(false)}>
                <IconButton
                    style={{position: "absolute", top: "0.15rem", right: "0.15rem", color: "white"}}
                    onClick={() => setShowTestCase(false)}
                    size="large">
                    <CloseIcon/>
                </IconButton>
                <TestCase partnerId={testCaseSummary.PartnerCoId} item={testCaseSummary} embedded onGenerate={(orderId) => {setRedirect("/order-management/order-details?orderid=" + orderId)}}/>
              </Dialog>}
          </Card>
    );
};

export default DocumentToolbar;
